import styled from "styled-components";

export const Map = styled.div`
  position: relative;
  height: 600px;
`;
